import IUserEventStorage from 'legacy/lut/classes/userEvents/IUserEventStorage'
import { appGetState } from 'legacy/lut/store'
import { lookupGetStateOld, setNextLookupState } from 'legacy/lut/store'

import { TEventName, IModel as TUserEvent } from './UserEvent'
import UserEventDispatcher from './UserEventDispatcher'
import { getUserEventStorageServer } from './UserEventStorageServer'

class UserEventService {
  protected isInitialized = false
  protected storage: IUserEventStorage | null = null
  protected dispatcher: UserEventDispatcher | null = null
  protected events: TUserEvent[] = []
  protected queue: TEventName[] = []
  protected processing: boolean = false
  private appGetState = appGetState

  public async init(storage?: IUserEventStorage) {
    if (!this.isInitialized) {
      const email = this.appGetState().user.email
      this.storage = storage || getUserEventStorageServer()
      this.events = await this.storage.fetch(email)
      this.dispatcher = new UserEventDispatcher(email)
      await this.updateState()
      this.isInitialized = true
    }
  }

  public async register(eventName: TEventName) {
    this.queue.push(eventName)
    await this.process()
  }

  public process = async () => {
    await this.init()
    if (this.dispatcher && this.storage && !this.processing) {
      while (this.queue.length) {
        this.processing = true
        const eventName = this.queue.shift()
        if (eventName) {
          // Check local before
          let event = this.dispatcher.dispatch(eventName, this.events)
          if (event) {
            // If event allowed then recheck with refreshed data from DB
            this.events = await this.storage.fetch(this.dispatcher.email)
            event = this.dispatcher.dispatch(eventName, this.events)
            if (event) {
              const persistedEvent = await this.storage.persist(event)
              this.events.push(persistedEvent)
              await this.updateState()
            }
          }
        }
      }
      this.processing = false
    }
  }

  public async updateState() {
    const userPoints = await this.getEventsTotal()
    const email = this.dispatcher && this.dispatcher.email ? this.dispatcher.email : ''
    let userLevel = (this.storage &&
      this.dispatcher &&
      (await this.storage.fetchLevel(this.dispatcher.email))) || {
      EntryId: null,
      Email: email,
      Level: -1,
    }
    if (!userLevel.EntryId) {
      userLevel.Email = this.dispatcher && this.dispatcher.email ? this.dispatcher.email : ''
      userLevel.Level = -1
      userLevel = (this.storage && this.dispatcher && (await this.storage.addLevel(userLevel))) || {
        EntryId: null,
        Email: email,
        Level: -1,
      }
    }
    const newUserLevel = userLevel !== null ? userLevel : { EntryId: null, Email: '', Level: -1 }
    const lookupOldState = lookupGetStateOld()
    setNextLookupState({
      ...lookupOldState,
      userLevel: newUserLevel,
      userPoints,
    })
  }

  protected async getEventsTotal(): Promise<number> {
    return this.events.reduce((a, i) => a + i.value, 0)
  }
}

export default new UserEventService()
